import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type LpnPage from './lpn-page.ts';
import type CompanySettingModel from './company-setting.ts';
import type { OutputData } from '@editorjs/editorjs';

export default class CompanyLpnSetting extends Model {
  @attr declare isEnabled: boolean;
  @attr declare employerRecommended: boolean;
  @attr declare cappedTuition: boolean;
  @attr declare hasDiscount: boolean;
  @attr declare discountPercent: number;
  @attr declare description?: OutputData;
  @attr declare url?: string;
  @attr declare badgeCappedTuition?: boolean;
  @attr declare badgeDiscount?: boolean;
  @attr declare badgeFamilySavings?: boolean;
  @attr declare badgeFeesWaived?: boolean;
  @attr declare providedBy?: string;
  @attr declare badgeCappedTuitionRange?: string;
  @attr declare discountPercentRange?: string;
  @attr declare saveDollarAmountRange?: string;
  @attr declare saveDollarAmountValue?: string;
  @attr declare saveDollarAmount?: boolean;
  @attr declare partTuitionWaiver?: boolean;
  @attr declare lowTuition?: boolean;
  @attr declare costPerCredit?: string;
  @attr declare costPerCreditRange?: string;
  @attr declare format?: string[];
  @attr declare programs?: string[];
  @attr declare areasOfStudy?: string[];
  @attr declare imageUrl?: string;

  // Use Range toggle booleans
  @attr declare useDiscountPercentRange?: boolean;
  @attr declare useSaveDollarAmountRange?: boolean;
  @attr declare useCostPerCreditRange?: boolean;

  get savingsPercentRange(): string | undefined {
    return this.discountPercentRange;
  }

  set savingsPercentRange(value: string | undefined) {
    this.discountPercentRange = value;
  }

  get savingsAmountRange(): string | undefined {
    return this.saveDollarAmountRange;
  }

  set savingsAmountRange(value: string | undefined) {
    this.saveDollarAmountRange = value;
  }

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('company-setting', { async: false, inverse: 'companyLpnSetting' })
  declare companySetting: CompanySettingModel;

  @belongsTo('lpn-page', { async: false, inverse: 'companyLpnSettings' })
  declare lpnPage: LpnPage;

  [Type] = 'company-lpn-setting' as const;
}
